export default {
    primary: '#AFAFAF',
   
}